import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RouterProps } from 'react-router';
import { SubPage, Tab } from 'providence-types';
import { canUserEditByProjectStatusAndRoles } from '@core/utils/methods';
import { EditablePage, LeasingEquipment } from '@shared/components';
import {
  LeasingSelectors,
  ProjectSelectors,
  UserSelectors,
} from '@store/selectors';

export const LeasingEquipmentTab: FC<RouterProps> = () => {
  const canEdit = useSelector(
    UserSelectors.canEdit('leasing', SubPage.LeasingBrowse, Tab.Equipment),
  );
  const userRoles = useSelector(UserSelectors.getUserRoles);
  const projectStatus = useSelector(ProjectSelectors.getProjectStatus);

  return (
    <EditablePage
      editableComponent={LeasingEquipment}
      canUserEdit={
        canEdit && canUserEditByProjectStatusAndRoles(projectStatus, userRoles)
      }
      data={useSelector(LeasingSelectors.getLeasingEquipmentData)}
    />
  );
};
